var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.qrCode)?_c('div',[_c('img',{attrs:{"src":_vm.qrCode,"alt":"QR Code"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }